import { Box, Image } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import {
  Wrapper,
  ContainerHeader,
  WrapperMain,
  ContainerContent,
  WrapperContent,
  WrapperImage,
  FirstLine,
  SecondLine,
} from './styles';
import { ReactComponent as LogoDaniel } from '../assets/logo-daniel.svg';
import { Terms } from './components';
import { FormRegisterSimulator } from './components/FormRegisterSimulator';
import HandsOnPhone from 'assets/images/maos-telefone2.png';
import { Footer } from './components/Footer';
import { FormSimulator } from './FormSimulator';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { SimulatorProvider } from './provider/SimulatorProvider';
import { Button } from 'components';
import './styles.css';

export const Simulator = () => {
  const [whatIsComponent, setComponent] = useState('register');

  useEffect(() => {
    document.title = 'DPOHUB | Simulador de Multas';

    return () => {
      document.title = 'DPOHUB';
    };
  }, []);

  const detectEnviroment = () => {
    if (location.href.includes('dpo-hub.daniel-ip.com')) {
      return process.env.REACT_APP_SITE_KEY_PROD as string;
    } else {
      return process.env.REACT_APP_SITE_KEY_STAGE as string;
    }
  };

  return (
    <SimulatorProvider>
      <Wrapper>
        <ContainerHeader>
          <LogoDaniel />
        </ContainerHeader>
        {whatIsComponent === 'register' ? (
          <WrapperMain>
            <FirstLine>
              <WrapperContent>
                <ContainerContent>
                  <h1>
                    Simule o valor <br /> da sua multa <br /> gratuitamente
                  </h1>
                  <Button
                    fullWidth={false}
                    style={{ width: '10rem' }}
                    onClick={() => {
                      window.scrollTo(0, 560);
                    }}
                  >
                    Simule agora!
                  </Button>
                </ContainerContent>
              </WrapperContent>
              <WrapperImage>
                <Box className="circleGeometric" />
                <Image src={HandsOnPhone} alt="Mãos no telefone" />
              </WrapperImage>
            </FirstLine>

            <SecondLine>
              <Terms setComponent={setComponent} />
              <GoogleReCaptchaProvider reCaptchaKey={detectEnviroment()}>
                <FormRegisterSimulator setComponent={setComponent} />
              </GoogleReCaptchaProvider>
            </SecondLine>
          </WrapperMain>
        ) : (
          <FormSimulator
            setComponent={setComponent}
            index={0}
            functionCallback={() => {}}
            submit={() => {}}
          />
        )}
        <Footer />
      </Wrapper>
    </SimulatorProvider>
  );
};
